enum ClaimsInsightsScoreTypeEnum {
  AverageScore = "Average Score",
  FiveStars = "5",
  FourStars = "4",
  ThreeStars = "3",
  TwoStars = "2",
  OneStar = "1",
  Unknown = "Unknown",
  Total = "Total",
}

export { ClaimsInsightsScoreTypeEnum };
